var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticStyle:{"text-align":"center"},attrs:{"colspan":_vm.colspan}},[_c('b',[_vm._v("Carry over")]),_vm._v(" - setting will carry over\n")])}
var staticRenderFns = []

export { render, staticRenderFns }